import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	notStartedProjects: { data: [], totalElements: 0, currentPage: 0 },
	inProgressProjects: { data: [], totalElements: 0, currentPage: 0 },
	completedProjects: { data: [], totalElements: 0, currentPage: 0 },
	selectedProjectToEdit: null,
	isShowCreateProjectModal: false,
	isEditProject: false,
	isShowDeleteProjectModal: false,
	selectedProjectIdToDelete: null
};

const myProjectSlice = createSlice({
	name: 'myProjects',
	initialState,
	reducers: {
		setNotStartedProjects: (state, { payload }) => {
			state.notStartedProjects = payload;
		},
		setInProgressProjects: (state, { payload }) => {
			state.inProgressProjects = payload;
		},
		setCompletedProjects: (state, { payload }) => {
			state.completedProjects = payload;
		},
		setSelectedProjectToEdit: (state, { payload }) => {
			state.selectedProjectToEdit = payload;
		},
		setIsShowCreateProjectModal: (state, { payload }) => {
			state.isShowCreateProjectModal = payload;
		},
		setIsEditProject: (state, { payload }) => {
			state.isEditProject = payload;
		},
		setIsShowDeleteProjectModal: (state, { payload }) => {
			state.isShowDeleteProjectModal = payload;
		},
		setSelectedProjectIdToDelete: (state, { payload }) => {
			state.selectedProjectIdToDelete = payload;
		}
	}
});

export const {
	setNotStartedProjects,
	setInProgressProjects,
	setCompletedProjects,
	setSelectedProjectToEdit,
	setIsShowCreateProjectModal,
	setIsEditProject,
	setIsShowDeleteProjectModal,
	setSelectedProjectIdToDelete
} = myProjectSlice.actions;

export default myProjectSlice.reducer;
